export const ACCESS_TOKEN_NAME = 'access_token'
export const REFRESH_TOKEN_NAME = 'refresh_token'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const USER_FULL_NAME = 'fullName'
export const USER_ID = 'userId'
export const FILE_MAX_SIZE = 157286400 /* 150Mb */
export const FILE_MERGE_MAX_SIZE = 157286400 /* 150Mb */
// export const PLAYLIST_MAX_SIZE = 524288000 /* 500Mb */
export const PLAYLIST_MAX_SIZE = 209715200 /* 200Mb */
// export const PLAYLIST_MAX_SIZE = 20971520 /* 20Mb */
export const IS_CHECK_MAX_SIZE_UPLOAD = process.env.IS_CHECK_MAX_SIZE_UPLOAD
export const FULL_NAME = 'full_name'
export const TIME_OTP_EXPIRED = 'time_otp_exp'
export const IS_VERIFY_OTP_WITH_MAIL = process.env.IS_VERIFY_OTP_WITH_MAIL
export const RESET_PASSWORD_REQUIRED = 'reset_password_required'
export const ACCESS_TOKEN_EXPIRED = 'access_token_exp'
export const CLIENT_ID = process.env.CLIENT_ID
export const CLIENT_ID_NAME = 'client-id'
export const IS_VERIFY_RECAPTCHA = false
export const PROVINCE_CODE = process.env.PROVINCE_CODE
export const PROVINCE_NAME = process.env.PROVINCE_NAME
export const REDIRECT_URI_NAME = 'redirect-uri'
export const CONFIG_AUTHORIZATION_CONNECT_PARTNER = process.env.CONFIG_AUTHORIZATION_CONNECT_PARTNER
export const LOCATION_CODE_NAME = 'location_code'
export const USER_POSITION = 'user_position'
export const NOTIFICATION_EMERGENCY = 'notification_emergency'

export const Authorities = {
  ROLE_ADMIN: 1,           /* Cấp admin */
  ROLE_SUPER_ADMIN: 2,        /* Cấp suoper */
  ROLE_CONSTRUCTION: 3,        /* Cấp thi công */
}